import { Button } from "@mui/material";
import React from "react";
import { Snackbar } from "../shared/Snackbar";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import { ContentCopy } from "@mui/icons-material";

interface CopyToClipboardProps {
  textToCopy: string;
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ textToCopy }) => {
  const { t } = useTranslation();
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  async function handleCopyToClipboard() {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setSnackbarMessage(t("common.copiedToClipboard"));
      setSnackbarOpen(true);
    } catch (err) {
      setSnackbarMessage(t("common.failedToCopy"));
      setSnackbarOpen(true);
    }
  }

  return (
    <>
      <Button variant="contained" color="secondary" onClick={handleCopyToClipboard} endIcon={<ContentCopy />}>
        {t("common.copyToClipboard")}
      </Button>
      <Snackbar open={snackbarOpen} onClose={() => setSnackbarOpen(false)}>
        <Typography>{snackbarMessage}</Typography>
      </Snackbar>
    </>
  );
};
